import React, { Component } from 'react';
import Firebase from 'firebase';
import 'firebase/functions';
import Connector from '../../data/Connector';
import Moment from 'moment';
import HelperBusiness from '../../helper/Business';
import { withRouter } from 'react-router-dom';
import HelperPage from '../../helper/Page';
import EventEmitter from '../../helper/Emitter';
import Navigation from '../../components/Navigation';
import Header from '../../components/Headers/form';
import ListEmpty from '../../components/List/empty';
import InputClient from '../../components/Form/client';
import InputText from '../../components/Form/input-text';
import InputNumber from '../../components/Form/input-number';
import InputDate from '../../components/Form/input-date';
import InputRadio from '../../components/Form/radio';
import InputToggle from '../../components/Form/toggle';
import Textarea from '../../components/Form/textarea';
import InfoPrice from '../../components/Form/price';
import WidgetFormInfo from '../../components/Widgets/forminfo';
import ModalClients from '../../components/Modals/clients';
import ModalMessageBasic from '../../components/Modals/message-basic';
import { withTranslation } from "react-i18next";
import lang from 'i18next';
import { AuthUserContext, withAuthorization } from '../../components/Session';



class NewInvoicePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      invoices: global.invoices,
      clients: global.clients,
      clientsList: global.clients,
      products: [],
      selected: [],
      client: null,
      account: '',
      type: 'sessions',
      due: 'today',
      gst: global.spaceGST,
      notes: '',
      date: Moment().format('YYYY-MM-DD'),
      showGST: false,
      showModalClients: false,
      showModalBasic: false,
    };
  }


  componentDidMount() {
    HelperPage.initializeForm('New Invoice - PT Mate')
    this._isMounted = true

    global.currentClient = '';
    EventEmitter.subscribe('userLoaded', (event) => this.configureData())
    EventEmitter.subscribe('clientsLoaded', (event) => this.configureData())
    EventEmitter.subscribe('productsLoaded', (event) => this.configureData())
    EventEmitter.subscribe('invoicesLoaded', (event) => this.configureData())
    this.configureData()
    var arr = this.props.location.pathname.split('/')
    if(arr[arr.length-1] !== 'new') {
      this.setState({id: arr[arr.length-1]})
    }
  }


  componentWillUnmount() {
    this._isMounted = false
    EventEmitter.unsubscribe('userLoaded', () => {})
    EventEmitter.unsubscribe('clientsLoaded', () => {})
    EventEmitter.unsubscribe('productsLoaded', () => {})
    EventEmitter.unsubscribe('invoicesLoaded', () => {})
  }


  configureData() {
    if(this._isMounted) {
      var tmp = []
      var tmp2 = []
      for(var item of global.products) {
        if(item.data.type === this.state.type) {
          tmp.push(item)
        }
      }
      for(var item2 of global.clients) {
        if(item2.data.parent === undefined || item2.data.parent === '') {
          tmp2.push(item2)
        }
      }
      var show = false
      if(global.spaceGST !== 0) {
        show = true
      }
      this.setState({
        invoices: global.invoices,
        clients: global.clients,
        clientsList: tmp2,
        products: tmp,
        selected: [],
        showGST: show
      })
    }
  }


  getFamilyName(id) {
    var label = 'Client'
    for(var item of global.clients) {
      if(item.id === id) {
        label = item.data.name
      }
    }
    return label
  }



  // Interactive ------------------------------------------------------------



  updateValues(val, key) {
    this.setState({
      [key]: val
    });
  }


  toggleType(value) {
    this.setState({
      type: value,
    }, () => {
      var tmp = []
      for(var item of global.products) {
        if(item.data.type === value) {
          tmp.push(item)
        }
      }
      this.setState({
        products: tmp,
        selected: [],
      })
    })
  }


  selectProduct(event) {
    if(event.target.value !== '') {
      var prod = null
      for(var item of this.state.products) {
        if(item.id === event.target.value) {
          prod = item
        }
      }
      var tmp = this.state.selected
      tmp.push(prod)
      this.setState({
        selected: tmp
      })
    }
  }


  getGST() {
    if(this.state.gst !== 0) {
      var price = 0
      for(var item of this.state.selected) {
        price += item.data.price
      }
      var mul = price/11
      var num = mul/10*this.state.gst
      return global.curSym+num.toFixed(2)
    }
  }


  getTotal() {
    var num = 0
    for(var item of this.state.selected) {
      num += item.data.price
    }
    return num.toFixed(2)
  }


  getProductInfo(type) {
    var label = ''
    for(var item of this.state.selected) {
      if(type === 'name') {
        label += '\n'+item.data.name
      } else if(type === 'price') {
        label += '\n'+global.curSym+item.data.price.toFixed(2)
      } else if(type === 'desc') {
        if(item.data.desc !== undefined) {
          label += '\n'+item.data.desc
        }
      }
    }
    label = label.substring(1)
    return label
  }


  removeItem(id) {
    var tmp = this.state.selected
    for(var i=0; i<tmp.length; i++) {
      if(tmp[i].id === id) {
        tmp.splice(i, 1)
      }
    }
    this.setState({
      selected: tmp
    })
  }


  checkCreateInvoice() {
    var valid = false
    valid = Moment(this.state.date, 'YYYY-MM-DD').isValid()
    if(this.state.due !== 'other') {
      valid = true
    }
    if(valid) {
      this.createInvoice()
    }
  }


  createInvoice() {
    var gst = null
    var gststr1 = ''
    var gststr2 = ''
    var date = Moment(this.state.date, 'YYYY-MM-DD').format('X')
    if(this.state.due === 'today') {
      date = Moment().format('X')
    } else if(this.state.due === '7days') {
      date = Moment().add(7, 'days').format('X')
    } else if(this.state.due === '30days') {
      date = Moment().add(30, 'days').format('X')
    }
    var number = ''+global.spaceInvoice
    if(global.spaceInvoice < 10) {
      number = '00'+global.spaceInvoice
    }
    if(global.spaceInvoice < 100 && global.spaceInvoice > 9) {
      number = '0'+global.spaceInvoice
    }

    var product = ''
    var price = 0
    for(var sel of this.state.selected) {
      product += ','+sel.id
      price += sel.data.price
    }
    product = product.substring(1)

    if(this.state.showGST) {
      if(this.state.gst !== '' && this.state.gst !== 0) {
        var mul = price/11
        var num = mul/10*this.state.gst
        gst = num
        gststr1 = global.curSym+num.toFixed(2)
        gststr2 = lang.t('messaging:label.gstincluded')
      }
    }

    var token = this.state.client.data.pushToken
    if(token !== undefined && token !== '') {
      Connector.sendPushNotification(token, lang.t('messaging:push.newinvoice.title'), global.userBusiness+lang.t('messaging:push.newinvoice.text'), 'invoice', "")
    }

    var obj = Firebase.database().ref('/invoices/'+global.uid).push()
    obj.update({
      client: this.state.client.id,
      account: this.state.account,
      product: product,
      price: price,
      gst: gst,
      notes: this.state.notes,
      date: parseInt(Moment().format('X')),
      due: parseInt(date),
      number: number,
      status: 'open',
    }).then(() => {
      global.message = lang.t('messaging:message.invoicecreated')
      this.props.history.push(global.currentPage)
    }).catch((error)=>{
      EventEmitter.dispatch('showMessageError', error.message);
    })

    if(this.state.email !== '') {
      var arr = this.state.emails.split(',')
      for(var ar of arr) {
        var email = ar.replace(' ', '')
        var arr2 = []
        var address = ''
        if(global.spaceAddress !== undefined) {
          arr2 = global.spaceAddress.split('||')
          if(arr2.length > 3) {
            address = arr2[0]+'\n'+arr2[1]+'\n'+arr2[2]+', '+arr2[3]
          }
        }
        if(global.spaceInvoice1 !== undefined && global.spaceInvoice1 !== '') {
          address = global.spaceInvoice1
        }

        var footer = global.spaceInvoice2
        if(this.state.notes !== '') {
          footer = this.state.notes+'\n\n'+global.spaceInvoice2
        }
        
        var callFunction = Firebase.functions().httpsCallable('sendInvoiceV2');
        callFunction({name: global.userBusiness, email: email, address: address, number: number, date: Moment().format('D MMM YYYY'), client: this.state.client.data.name, phone: this.state.client.data.phone, product: this.getProductInfo('name'), price: this.getProductInfo('price'), total: global.curSym+price.toFixed(2), link: 'https://ptmate.me/'+global.uid+'/admin/pay-invoice/'+obj.key, footer: footer, due: Moment(date, 'X').format('D MMM YYYY'), gst1: gststr1, gst2: gststr2, desc: this.getProductInfo('desc')}).then(function(result) {});
      }
    }

    Firebase.database().ref('/spaces/'+global.uid).update({
      invoice: (global.spaceInvoice+1)
    })
  }



  // Modals ------------------------------------------------------------



  hideModals() {
    this.setState({
      showModalClients: false,
      showModalBasic: false,
    })
  }


  modalClick(item) {
    this.hideModals()
    this.setState({
      client: item,
      emails: item.data.email
    })
    if(item.data.uid !== '') {
      Connector.getClientToken(item.data.uid)
    }
  }



  // Display stuff ------------------------------------------------------------



  renderFamily() {
    if(this.state.client !== null) {
      if(this.state.client.data.linked !== undefined) {
        return (
          <div className="mb-20">
            <label>{lang.t('billing:label.assignedto')}</label>
            <select onChange={event => this.setState({account: event.target.value})} value={this.state.account}>
              <option value=''>{lang.t('billing:label.family')}</option>
              <option value={this.state.client.id} key={this.state.client.id}>{this.state.client.data.name}</option>
              {this.state.client.data.linked.map(item => (
                <option value={item} key={item}>{this.getFamilyName(item)}</option>
              ))}
            </select>
          </div>
        )
      }
    }
  }


  renderProductGroup(item) {
    if(this.state.type === 'sessions' && item.data.stype === '11') {
      return lang.t('billing:label.form11')
    } else if(this.state.type === 'sessions' && item.data.stype === 'group') {
      return lang.t('billing:label.formgroup')
    } else if(this.state.type === 'sessions' && item.data.stype === 'both') {
      return lang.t('billing:label.formgroup11')
    }
  }


  renderDate() {
    if(this.state.due === 'other') {
      return <InputDate label={lang.t('billing:form.due.label')+"*"} value={Moment(this.state.date, 'YYYY-MM-DD').format('YYYY-MM-DD')} format='YYYY-MM-DD' placeholder="Select a date" onChange={(event) => this.updateValues(event, 'date')}/>
    }
  }


  renderGST() {
    if(this.state.showGST) {
      return (
        <InputNumber label={lang.t('billing:form.includegst.label')} value={this.state.gst} onChange={(event) => this.setState({gst: parseFloat(event)})} info={this.getGST()}/>
      )
    }
  }


  renderBottom() {
    if(this.state.selected.length > 0 && this.state.client !== null) {
      return (
        <div>
          <InputToggle label={lang.t('billing:form.includegst')} value={this.state.showGST} onChange={() => this.setState({showGST: !this.state.showGST})} text={lang.t('billing:form.includegst.text')}/>
          {this.renderGST()}
          <InputRadio
            label={lang.t('billing:label.due')}
            value={this.state.due}
            clickElement={(event) => this.setState({due: event})}
            values={[{name: lang.t('billing:form.due.today'), value: 'today'}, {name: lang.t('billing:form.due.7days'), value: '7days'}, {name: lang.t('billing:form.due.30days'), value: '30days'}, {name: lang.t('billing:form.due.other'), value: 'other'}]}
          />
          <Textarea label={'Notes (optional)'} value={this.state.notes} onChange={(event) => this.setState({notes: event})}/>
          {this.renderDate()}
          <InputText label={lang.t('billing:form.sendto')} value={this.state.emails} onChange={(event) => this.updateValues(event, 'emails')} info={lang.t('billing:form.sendto.info')}/>
          <button className="btn primary mt-20" onClick={() => this.checkCreateInvoice()}>{lang.t('billing:button.createinvoice')}</button>
        </div>
      )
    }
  }


  renderProducts() {
    if(this.state.selected.length > 0) {
      var list = this.state.selected
      return (
        <div className="info">
          <label style={{marginBottom: 5}}>{lang.t('billing:form.items')}</label>
          {list.map(item => (
            <div style={{marginBottom: 5}}>
              <button className="btn tertiary close small rgt" onClick={() => this.removeItem(item.id)}>{lang.t('common:button.remove')}</button>
              {item.data.name}<br/>
              <span style={{fontSize: 11}}>{global.curSym}{item.data.price.toFixed(2)}</span>
            </div>
          ))}
        </div>
      )
    }
  }


  renderPrice() {
    if(this.state.selected.length > 0) {
      return (
        <div className="info">
          <label>{lang.t('billing:form.total')}</label>
          <p className="large">{global.curSym}{this.getTotal()}</p>
        </div>
      )
    }
  }


  renderForm() {
    return (
      <div>
        <InputClient id='invoice' client={this.state.client} clickElement={() => this.setState({showModalClients: true})}/>
        <div className="sv-20"></div>
        {this.renderFamily()}
        <InputRadio
          label={lang.t('billing:form.producttype')}
          value={this.state.type}
          clickElement={(event) => this.toggleType(event)}
          values={[{name: lang.t('billing:form.packofsessions'), value: 'sessions'}, {name: lang.t('billing:form.other'), value: 'other'}]}
        />
        <label>{lang.t('billing:form.addproduct')}</label>
        <select onChange={event => this.selectProduct(event)}>
          <option value={''}>- {lang.t('billing:form.pleaseselect')} -</option>
          {this.state.products.map(item => (
            <option value={item.id} key={item.id}>{item.data.name} {this.renderProductGroup(item)}</option>
          ))}
        </select>
        <div className="sv-20"></div>
        {this.renderProducts()}
        {this.renderPrice()}
        {this.renderBottom()}
      </div>
    )
  }


  renderBase() {
    if(HelperBusiness.getRoleIncl('admin')) {
      return (
        <div className={'theme-'+global.spaceTheme}>
          <div className="content form-sidebar">
            <div className="col-6 mt-20">
              <div className="box">
                {this.renderForm()}
              </div>
            </div>
            <div className="col-6 mt-20">
              <div className="sidebar">
                <WidgetFormInfo id='newinvoice'/>
              </div>
            </div>
            <div className="clear sv-40"></div>
          </div>
          <Header title={lang.t('billing:title.newinvoice')} link={global.currentPage}/>
          <Navigation active='billing' />
          <ModalClients clients={this.state.clientsList} show={this.state.showModalClients} onHide={() => this.hideModals()} clickElement={(event) => this.modalClick(event)}/>
        </div>
      )
    } else {
      return (
        <div className={'theme-'+global.spaceTheme}>
          <div className="content">
            <ListEmpty id='invoices-locked2' type='simple'/>
          </div>
          <Header title={lang.t('billing:title.newinvoice')} link={global.currentPage}/>
          <Navigation active='billing' />
        </div>
      )
    }
    
  }


  render() {
    return (
      <AuthUserContext.Consumer>
        {authUser => (
          this.renderBase()
        )}
      </AuthUserContext.Consumer>
    )
  }
}



const condition = authUser => !!authUser;
export default withTranslation(['billing','common','header','messaging'])(withRouter(withAuthorization(condition)(NewInvoicePage)));